// extracted by mini-css-extract-plugin
export default {"container":"EmptyTable_container__EbZmH","emptyState":"EmptyTable_emptyState__7zoMm","smallImage":"EmptyTable_smallImage__sFDys"};